import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { useLDClient } from 'launchdarkly-react-client-sdk';

import { environment } from 'environments/environment';

export const initializeLaunchDarkly = async () => {
  return await asyncWithLDProvider({
    clientSideID: environment.gcvConfig.launchDarklyClientSideId,
    options: {
      // Disable console logging in development
      ...(process.env.NODE_ENV === 'development' && {
        logger: {
          debug: () => false,
          info: () => false,
          warn: () => false,
          error: () => false
        }
      })
    }
  });
};

export const identifyLaunchDarklyUser = (
  userId: string,
  email: string,
  firstName: string,
  lastName: string,
  orgId: string,
  orgName: string
) => {
  const ldClient = useLDClient();
  ldClient?.identify({
    kind: 'multi',
    user: {
      key: userId,
      email: email,
      name: `${firstName} ${lastName}`
    },
    org: {
      key: orgId,
      name: orgName
    }
  });
};
